/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { OauthService } from '../services/oauth.service';

const oauthState = {
  consentURL: null,
};

const mutations = {

  setConsentURL(state, data) {
    state.consentURL = data;
  },

};

const getters = {
  consentURL: state => state.consentURL,
};

const actions = {
  createShopifyConnection: async ({}, params) => {
    try {
      await OauthService.createShopifyConnection(params);
      return true;
    } catch (e) {
      return false;
    }
  },

  getShopifyConsentURL: async ({ commit }, params) => {
    try {
      const resp = await OauthService.getShopifyConsentURL(params);
      commit('setConsentURL', resp.url);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: oauthState,
  mutations,
  getters,
  actions,
};
